/**
 * This is lazy loading config that initiate when open the webpage
 * DON'T import any module here. Ohterwise, the module will be loaded and lost the lazy loading.
 * */

import { withAsync } from '../../components/lazyLoading/async-component';

const MODULE_FOLDER_NAME = 'partners'; // Folder name of the module for lazy import
const MODULE_NAME = 'hk-emma-web-module-partners'; // Module name from package.json
const ROOT_PATHS = ['home/partners']; // Root path of the routes

export default {
  modules: [
    {
      moduleName: MODULE_NAME,
      routes: {
        rootPaths: ROOT_PATHS,
        subPaths: {
          '/:name/redirect': {
            exact: true,
            container: withAsync(MODULE_FOLDER_NAME, '/:name/redirect'),
          },
        },
      },
    },
  ],
};
